export const BINDER_ADD_FOLDER_WITH_TABS = "BINDER_ADD_FOLDER_WITH_TABS";
export const BINDER_ADD_ORDER_ITEM = "BINDER_ADD_ORDER_ITEM";
export const BINDER_SET_ANALYTICS_OPEN = "BINDER_SET_ANALYTICS_OPEN";
export const BINDER_SET_CHANGE_WARNING_OPEN = "BINDER_SET_CHANGE_WARNING_OPEN";
export const BINDER_SET_CURRENT_BINDER = "BINDER_SET_CURRENT_BINDER";
export const BINDER_SET_CURRENT_BOOKMARKED = "BINDER_SET_CURRENT_BOOKMARKED";
export const BINDER_SET_CURRENT_DIRTY = "BINDER_SET_CURRENT_DIRTY";
export const BINDER_SET_CURRENT_TAB_ID = "BINDER_SET_CURRENT_TAB_ID";
export const BINDER_TABS_ADD_TILE_SECTION = "BINDER_TABS_ADD_TILE_SECTION";
export const BINDER_TABS_REMOVE = "BINDER_TABS_REMOVE";
export const BINDER_TABS_SET = "BINDER_TABS_SET";
export const BINDER_TABS_SET_ANAYLTICS_CHART_META = "BINDER_TABS_SET_ANAYLTICS_CHART_META";
export const BINDER_TABS_SET_ANAYLTICS_TABLE_META = "BINDER_TABS_SET_ANAYLTICS_TABLE_META";
export const BINDER_TABS_SET_CHART_CONTENT = "BINDER_TABS_SET_CHART_CONTENT";
export const BINDER_TABS_SET_DATA_WARNING_SHOWN = "BINDER_TABS_SET_DATA_WARNING_SHOWN";
export const BINDER_TABS_SET_PROFILE = "BINDER_TABS_SET_PROFILE";
export const BINDER_TABS_SET_PROFILE_SECTION_EXPANDED = "BINDER_TABS_SET_PROFILE_SECTION_EXPANDED";
export const BINDER_TABS_SET_SEARCH_COL_ORDER = "BINDER_TABS_SET_SEARCH_COL_ORDER";
export const BINDER_TABS_SET_SEARCH_COL_WIDTH = "BINDER_TABS_SET_SEARCH_COL_WIDTH";
export const BINDER_TABS_SET_SEARCH_FIELD_NAMES = "BINDER_TABS_SET_SEARCH_FIELD_NAMES";
export const BINDER_TABS_SET_SEARCH_SORT = "BINDER_TABS_SET_SEARCH_SORT";
export const BINDER_TABS_SET_SEARCH_TARGET = "BINDER_TABS_SET_SEARCH_TARGET";
export const BINDER_TABS_ADD_TABLEAU_FILTER = "BINDER_TABS_ADD_TABLEAU_FILTER";
export const BINDER_TABS_ADD_TABLEAU_PARAMETER = "BINDER_TABS_ADD_TABLEAU_PARAMETER";
export const BINDER_TABS_RESET_TABLEAU_VALUES = "BINDER_TABS_RESET_TABLEAU_VALUES";
export const BINDER_TABS_SET_TILE_CONTENT = "BINDER_TABS_SET_TILE_CONTENT";
export const BINDER_TABS_SET_TILE_SECTIONS = "BINDER_TABS_SET_TILE_SECTIONS";
export const BINDER_TABS_SET_TITLE = "BINDER_TABS_SET_TITLE";
export const BINDER_TABS_SET_ROWS_HIDDEN = "BINDER_TABS_SET_ROWS_HIDDEN";
export const BINDER_TABS_SET_ALL_ROWS_HIDDEN = "BINDER_TABS_SET_ALL_ROWS_HIDDEN";
export const BINDER_TABS_RESET_HIDDEN_ROWS = "BINDER_TABS_RESET_HIDDEN_ROWS";
export const BINDER_TABS_TOGGLE_SELECT_HIDDEN = "BINDER_TABS_TOGGLE_SELECT_HIDDEN";
export const BINDERS_ADD_OBSERVER = "BINDERS_ADD_OBSERVER";
export const BINDERS_RELABEL_FOLDER = "BINDERS_RELABEL_FOLDER";
export const BINDERS_REMOVE = "BINDERS_REMOVE";
export const BINDERS_REMOVE_OBSERVER = "BINDERS_REMOVE_OBSERVER";
export const BINDERS_REORDER_ITEMS = "BINDERS_REORDER_ITEMS";
export const BINDERS_SAVE = "BINDERS_SAVE";
export const BINDERS_SET = "BINDERS_SET";
export const BINDERS_SET_ALERT_HISTORY = "BINDERS_SET_ALERT_HISTORY";
export const BINDERS_SET_ALERT_RATE = "BINDERS_SET_ALERT_RATE";
export const BINDERS_SET_BOOKMARKED = "BINDERS_SET_BOOKMARKED";
export const BINDERS_SET_CLIENT_CODE = "BINDERS_SET_CLIENT_CODE";
export const BINDERS_SET_DESCRIPTION = "BINDERS_SET_DESCRIPTION";
export const BINDERS_SET_EDITABLE = "BINDERS_SET_EDITABLE";
export const BINDERS_SET_MULTIPLE = "BINDERS_SET_MULTIPLE";
export const BINDERS_SET_OBSERVERS = "BINDERS_SET_OBSERVERS";
export const BINDERS_SET_OWNER = "BINDERS_SET_OWNER";
export const BINDERS_SET_TITLE = "BINDERS_SET_TITLE";
export const CRITERION_ADD = "CRITERION_ADD";
export const CRITERION_ADD_MULTIPLE = "CRITERION_ADD_MULTIPLE";
export const CRITERION_ADD_MULTIPLE_LAYOUT_TAB = "CRITERION_ADD_MULTIPLE_LAYOUT_TAB";
export const CRITERION_EDITORS_SET = "CRITERION_EDITORS_SET";
export const CRITERION_REMOVE = "CRITERION_REMOVE";
export const CRITERION_REMOVE_MULTIPLE = "CRITERION_REMOVE_MULTIPLE";
export const CRITERION_SET_JOINPATH = "CRITERION_SET_JOINPATH";
export const CRITERION_SET_VALUE = "CRITERION_SET_VALUE";
export const CRITERION_SET_VALUE_MULTIPLE = "CRITERION_SET_VALUE_MULTIPLE";
export const FIELDS_SET = "FIELDS_SET";
export const GROUP_LIBRARIES_SET = "GROUP_LIBRARIES_SET";
export const GROUPS_REMOVE_USERS = "GROUPS_REMOVE_USERS";
export const GROUPS_SET = "GROUPS_SET";
export const GROUPS_SET_DATA = "GROUPS_SET_DATA";
export const GROUPS_SET_USERS = "GROUPS_SET_USERS";
export const GROUPS_UPDATE_LIBRARIES = "GROUPS_UPDATE_LIBRARIES";
export const GROUPS_UPDATE_LIBRARY_SERVICE = "GROUPS_UPDATE_LIBRARY_SERVICE";
export const JOINPATHS_SET = "JOINPATHS_SET";
export const LIBRARY_SET_AVAILABLE = "LIBRARY_SET_AVAILABLE";
export const OBSERVER_ADD = "OBSERVER_ADD";
export const OBSERVER_ADD_MULTIPLE = "OBSERVER_ADD_MULTIPLE";
export const OBSERVER_REMOVE_MULTIPLE = "OBSERVER_REMOVE_MULTIPLE";
export const OBSERVER_UPDATE = "OBSERVER_UPDATE";
export const OBSERVER_UPDATE_MULTIPLE = "OBSERVER_UPDATE_MULTIPLE";
export const PAGE_ADD_DIALOG = "PAGE_ADD_DIALOG";
export const PAGE_REMOVE_DIALOG = "PAGE_REMOVE_DIALOG";
export const PAGE_REMOVE_TOAST = "PAGE_REMOVE_TOAST";
export const PAGE_REMOVE_TOASTS = "PAGE_REMOVE_TOASTS";
export const PAGE_SET_CLIENT_OUTDATED = "PAGE_SET_CLIENT_OUTDATED";
export const PAGE_SET_CLIENT_UNAUTH = "PAGE_SET_CLIENT_UNAUTHORIZED";
export const PAGE_SET_DESCRIPTION = "PAGE_SET_DESCRIPTION";
export const PAGE_SET_ERROR_DIALOG_OPEN = "PAGE_SET_ERROR_DIALOG_OPEN";
export const PAGE_SET_INITIAL_RENDER = "PAGE_SET_INITIAL_RENDER";
export const PAGE_SET_PATHNAME = "PAGE_SET_PATHNAME";
export const PAGE_SET_SCHEDULED_MAINTENANCE = "PAGE_SET_SCHEDULED_MAINTENANCE";
export const PAGE_SET_SERVICE_UNAVAILABLE = "PAGE_SET_SERVICE_UNAVAILABLE";
export const PAGE_SET_SI_PROMISE = "PAGE_SET_SI_PROMISE";
export const PAGE_SET_TOAST = "PAGE_SET_TOAST";
export const PAGE_SET_TOAST_VISIBLE = "PAGE_SET_TOAST_VISIBLE";
export const PAGE_SET_TOASTS_VISIBLE = "PAGE_SET_TOASTS_VISIBLE";
export const PAGE_WINDOW_RESIZED = "PAGE_WINDOW_RESIZED";
export const REPORT_SEARCH_DELETE = "REPORT_SEARCH_DELETE";
export const REPORT_SEARCH_START = "REPORT_SEARCH_START";
export const SEARCH_DELETE = "SEARCH_DELETE";
export const SEARCH_FIELDS_SET = "SEARCH_FIELDS_SET";
export const SEARCH_SET_API_OBJ = "SEARCH_SET_API_OBJ";
export const SEARCH_SET_TABS = "SEARCH_SET_TABS";
export const SEARCH_RELATED_START_LOAD = "SEARCH_RELATED_START_LOAD";
export const SEARCH_RELATED_END_LOAD = "SEARCH_RELATED_END_LOAD";
export const SEARCH_RELATED_UPDATE = "SEARCH_RELATED_UPDATE";
export const SEARCH_START = "SEARCH_START";
export const SEARCH_TAB_ADD = "SEARCH_TAB_ADD";
export const SEARCH_TAB_REMOVE_MULTIPLE = "SEARCH_TAB_REMOVE_MULTIPLE";
export const SEARCH_TAB_SET_LOADING = "SEARCH_TAB_SET_LOADING";
export const SESSION_SET_AUTHENTICATED = "SESSION_SET_AUTHENTICATED";
export const SESSION_SET_PAGE_AUTH_SUSPENDED = "SESSION_SET_PAGE_AUTH_SUSPENDED";
export const SESSION_UPDATE_USER = "SESSION_UPDATE_USER";
export const SESSION_UPDATE_USER_PRACTICE_AREAS = "SESSION_UPDATE_USER_PRACTICE_AREAS";
export const SESSION_UPDATE_USER_TOKEN = "SESSION_UPDATE_USER_TOKEN";
export const TARGETS_RESET = "TARGETS_RESET";
export const TARGETS_SET = "TARGETS_SET";
export const TILE_ADD = "TILE_ADD";
export const TILE_ADD_MULTIPLE = "TILE_ADD_MULTIPLE";
export const TILE_REMOVE_MULTIPLE = "TILE_REMOVE_MULTIPLE";
export const TILE_SECTION_ADD = "TILE_SECTION_ADD";
export const TILE_SECTION_ADD_MULTIPLE = "TILE_SECTION_ADD_MULTIPLE";
export const TILE_SECTION_REMOVE = "TILE_SECTION_REMOVE";
export const TILE_SECTION_REMOVE_MULTIPLE = "TILE_SECTION_REMOVE_MULTIPLE";
export const TILE_SET_LOADED = "TILE_SET_LOADED";
export const UI_SET_ACTIVE_REPORT_SEARCH_ID = "UI_SET_ACTIVE_REPORT_SEARCH_ID";
export const UI_SET_ACTIVE_SEARCH_ID = "UI_SET_ACTIVE_SEARCH_ID";
export const UI_SET_BINDER_TAB_DRAWER_OPEN = "UI_SET_BINDER_TAB_DRAWER_OPEN";
export const UI_SET_BINDER_TAB_TYPE = "UI_SET_BINDER_TAB_TYPE";
export const UI_SET_CHANGE_WARNING_OPEN = "UI_SET_CHANGE_WARNING_OPEN";
export const UI_SET_CURRENT_BINDER = "UI_SET_CURRENT_BINDER";
export const UI_SET_PRINT_PREVIEW = "UI_SET_PRINT_PREVIEW";
export const UI_SET_PRINT_PREVIEW_DETAILS = "UI_SET_PRINT_PREVIEW_DETAILS";
export const USERS_ACTIVATE_LIBRARIES = "USERS_ACTIVATE_LIBRARIES";
export const USERS_ADD = "USERS_ADD";
export const USERS_REMOVE = "USERS_REMOVE";
export const USERS_SET = "USERS_SET";
export const USERS_SET_ACTIVE_LIBRARIES = "USERS_SET_ACTIVE_LIBRARIES";
export const USERS_SET_MULTIPLE = "USERS_SET_MULTIPLE";
export const USERS_UPDATE_PERSONAL_INFO = "USERS_UPDATE_PERSONAL_INFO";
export const USERS_TOGGLE_PRACTICE_AREA_FIELD = "USERS_TOGGLE_PRACTICE_AREA_FIELD";
export const UPC_UPDATE_LITIGATED_PATENTS_FILTERS = "UPC_UPDATE_LITIGATED_PATENTS_FILTERS";
export const UPC_UPDATE_OPT_OUT_FILTERS = "UPC_UPDATE_OPT_OUT_FILTERS";
export const UPC_UPDATE_ORDERS_FILTERS = "UPC_UPDATE_ORDERS_FILTERS";
export const UPC_UPDATE_IAM_NEWS_ARCHIVE_FILTERS = "UPC_UPDATE_IAM_NEWS_ARCHIVE_FILTERS";
export const QUICK_SEARCH_UPDATE_QUERY = "QUICK_SEARCH_UPDATE_QUERY";
export const QUICK_SEARCH_UPDATE_FILTER = "QUICK_SEARCH_UPDATE_FILTER";
export const QUICK_SEARCH_UPDATE_SELECTED_TIME_FRAME = "QUICK_SEARCH_UPDATE_SELECTED_TIME_FRAME";
export const QUICK_SEARCH_UPDATE_SELECTED_TIME_VALUE = "QUICK_SEARCH_UPDATE_SELECTED_TIME_VALUE";
export const QUICK_SEARCH_UPDATE_SESSION_SEARCH_VALUES =
	"QUICK_SEARCH_UPDATE_SESSION_SEARCH_VALUES";
export const DOCKET_REPORT_UPDATE_FILTERS = "DOCKET_REPORT_UPDATE_FILTERS";
